var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTopRightSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.755 27h14.49C25.757 27 27 25.757 27 23.296V8.705C27 6.243 25.757 5 23.245 5H8.755C6.258 5 5 6.231 5 8.705v14.59C5 25.77 6.258 27 8.755 27zm2.091-7.453c-.465.465-.43 1.116.025 1.57.466.466 1.106.491 1.571.026l6.9-7.088v4.558c-.01.294.098.57.32.792a1.065 1.065 0 0 0 1.528.01c.222-.223.324-.486.323-.769v-6.938c0-.404-.09-.677-.323-.91-.222-.223-.475-.314-.9-.313l-6.948-.01c-.283 0-.526.12-.749.343a1.053 1.053 0 0 0 0 1.517c.213.213.506.324.79.324h4.562z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRightSquare);
export default __webpack_public_path__ + "static/media/Arrow_Top-Right-Square.8c5838c6fce8a854856644802bc3189b.svg";
export { ForwardRef as ReactComponent };